module.exports = __webpack_public_path__ + "static/media/card-logo-visa.48f0b9fa.svg";